module.exports = __webpack_public_path__ + "img/bp-buttons.bc158419.svg";